import React from 'react';
import PropTypes from 'prop-types';
import './Hero.scss';
import MediaQuery from 'react-responsive';
import VideoCoverFallback from 'react-video-cover';
import Responsive from 'react-responsive';


const propTypes = {
    poster: PropTypes.string,
    posterMobile: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    videoSrcDesktop: PropTypes.string,
    videoSrcMobile: PropTypes.string,
    isVid: PropTypes.bool,
};


export default class Hero extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        const Desktop = props => <Responsive {...props} minWidth={1200} />;
        const DesktopSm = props => <Responsive {...props} minWidth={1025} maxWidth={1199} />;
        const Tablet = props => <Responsive {...props} minWidth={770} maxWidth={1024} />;
        const MobileLg = props => <Responsive {...props} minWidth={416} maxWidth={769} />;
        const MobileMd = props => <Responsive {...props} minWidth={321} maxWidth={415} />;
        const MobileSm = props => <Responsive {...props} maxWidth={320} />;

        const{poster, posterMobile, videoSrcDesktop, videoSrcMobile, title, subtitle, description, isVid} = this.props;

        const style = {
            width: '100%',
            height: '100%',
            position: 'relative',
            overflow: 'hidden',
            maxHeight: '720px',
        };

        const videoOptionsD = {
            style: {
                position: 'relative',
            },
            poster: poster,
            src: videoSrcDesktop,
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true
        };

        const videoOptionsDSm = {
            style: {
                width: '100%',
                height: '562px',
                objectFit: 'cover',
            },
            poster: poster,
            src: videoSrcDesktop,
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true
        };

        const videoOptionsT = {
            style: {
                width: '100%',
                height: '800px',
                objectFit: 'cover',
            },
            poster: posterMobile,
            src: videoSrcMobile,
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true
        };
        const videoOptionsMlg = {
            style: {
                width: '100%',
                height: '600px',
                objectFit: 'cover',
            },
            poster: posterMobile,
            src: videoSrcMobile,
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true
        };
        const videoOptionsMmd = {
            style: {
                width: '100%',
                height: '534px',
                objectFit: 'cover',
            },
            poster: posterMobile,
            src: videoSrcMobile,
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true
        };

        const videoOptionsMsm = {
            style: {
                width: '100%',
                height: '483px',
                objectFit: 'cover',
            },
            poster: posterMobile,
            src: videoSrcMobile,
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true
        };

        return(
            <div>
                {isVid === true ?
                    <div className='hero--vid--container'>
                        <div className="holder__amb">
                            <Desktop>
                                <VideoCoverFallback className="vid-base"
                                                    videoOptions={videoOptionsD}
                                                    remeasureOnWindowResize
                                                    getResizeNotifier={resizeNotifier => {
                                                        this.setState({
                                                            resizeNotifier,
                                                        });
                                                    }}
                                />
                            </Desktop>
                            <DesktopSm>
                                <VideoCoverFallback className="vid-base"
                                                    videoOptions={videoOptionsDSm}
                                                    remeasureOnWindowResize
                                                    getResizeNotifier={resizeNotifier => {
                                                        this.setState({
                                                            resizeNotifier,
                                                        });
                                                    }}
                                />
                            </DesktopSm>
                            <Tablet>
                                <VideoCoverFallback className="vid-base"
                                                    videoOptions={videoOptionsT}
                                                    remeasureOnWindowResize
                                                    getResizeNotifier={resizeNotifier => {
                                                        this.setState({
                                                            resizeNotifier,
                                                        });
                                                    }}
                                />
                            </Tablet>
                            <MobileLg>
                                <VideoCoverFallback className="vid-base"
                                                    videoOptions={videoOptionsMlg}
                                                    remeasureOnWindowResize
                                                    getResizeNotifier={resizeNotifier => {
                                                        this.setState({
                                                            resizeNotifier,
                                                        });
                                                    }}
                                />
                            </MobileLg>
                            <MobileMd>
                                <VideoCoverFallback className="vid-base"
                                                    videoOptions={videoOptionsMmd}
                                                    remeasureOnWindowResize
                                                    getResizeNotifier={resizeNotifier => {
                                                        this.setState({
                                                            resizeNotifier,
                                                        });
                                                    }}
                                />
                            </MobileMd>
                            <MobileSm>
                                <VideoCoverFallback className="vid-base"
                                                    videoOptions={videoOptionsMsm}
                                                    remeasureOnWindowResize
                                                    getResizeNotifier={resizeNotifier => {
                                                        this.setState({
                                                            resizeNotifier,
                                                        });
                                                    }}
                                />
                            </MobileSm>
                            <div className='flex--overlay--one'>
                                <div className='vidOverlay--one '>
                                    <h3 className='hero--subheading '> {description} </h3>
                                    <div className="full-bleed-hrdiv"></div>
                                    <h1 className='first--line typ--heading typ--white '> {title} </h1>
                                    <h1 className='second--line typ--heading typ--white '> {subtitle}</h1>
                                </div>
                            </div>
                        </div>
                    </div> :
                    <div className='img-hero-container'>
                        <div className='background-hold'>
                            <img className='poster-img' src={poster}/>
                            <div className='flex--overlay--one'>
                                <div className='vidOverlay--one '>
                                    <h3 className='hero--subheading '> {description} </h3>
                                    <div className="full-bleed-hrdiv"></div>
                                    <h1 className='first--line typ--heading typ--white '> {title} </h1>
                                    <h1 className='second--line typ--heading typ--white '> {subtitle}</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
};

Hero.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/Hero/index.js